import { render, staticRenderFns } from "./asn.vue?vue&type=template&id=2af90843&"
import script from "./asn.vue?vue&type=script&lang=js&"
export * from "./asn.vue?vue&type=script&lang=js&"
import style0 from "./asn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports